export const ULR_PATHS = {
    AUTO_LIVE_STREAM: 'customer/livestreamsettings',
    AUTO_REC_STREAM: 'customer/recordsettings',
    LIVESTREAM_USAGE_UPDATE: 'customer/saverecordings'
};


export const FakeParticipant = Object.freeze({
    LocalScreenShare: 'LocalScreenShare',
    RemoteScreenShare: 'RemoteScreenShare',
    SharedVideo: 'SharedVideo',
    Whiteboard: 'Whiteboard'
});
